import { documentComponent } from '@/core'
import { documentedComponents as coreDocumentedComponents } from '@/core/components'
import { Button } from '@c/button'
import { BarGraph } from '@c/bar-graph'
import { IconButton } from '@c/icon-button'
import { Card } from '@c/card'
import { TypeaheadPurposely } from '@c/typeahead-purposely'
import { AdminMenu } from '@c/admin-menu'
import { AdminMetrics } from '@c/admin-metrics'
import { AdminAddNonprofitOwner } from '@c/admin-add-nonprofit-owner'
import { AdminEmployeeList } from '@c/admin-employee-list'
import { UserList as UserListPurposely } from '@c/user-list'
import { Header } from '@c/header'
import { Logo } from '@c/logo'
import { CardLayout } from '@c/card-layout'
import { SignupPage } from '@c/auth-app/signup-page'
import { SignupWithEmailPage } from '@c/auth-app/signup-with-email-page'
import { LoginPage } from '@c/auth-app/login-page'
import { LoginWithEmailPage } from '@c/auth-app/login-with-email-page'
import { ResetPasswordPage } from '@c/auth-app/reset-password-page'
import { ResetPasswordSuccessPage } from '@c/auth-app/reset-password-success-page'
import { ConfirmEmailPage } from '@c/auth-app/confirm-email-page'
import { ConfirmEmployeeTypePage } from '@c/auth-app/confirm-employee-type-page'
import { ConfirmEmailSuccessPage } from '@c/auth-app/confirm-email-success-page'
import { ForgotPasswordPage } from '@c/auth-app/forgot-password-page'
import { ForgotPasswordSuccessPage } from '@c/auth-app/forgot-password-success-page'
import { SkillSelect } from '@c/skill-select'

export const components = {
  ...coreDocumentedComponents,
  Button,
  IconButton,
  Card,
  BarGraph,
  TypeaheadPurposely,
  AdminMetrics,
  AdminMenu,
  AdminAddNonprofitOwner,
  AdminEmployeeList,
  UserListPurposely,
  Header,
  Logo,
  CardLayout,
  SignupPage,
  SignupWithEmailPage,
  LoginPage,
  LoginWithEmailPage,
  ResetPasswordPage,
  ResetPasswordSuccessPage,
  ForgotPasswordPage,
  ForgotPasswordSuccessPage,
  ConfirmEmailPage,
  ConfirmEmployeeTypePage,
  ConfirmEmailSuccessPage,
  SkillSelect,
}

export const documentedComponents = Object.keys(components).reduce((acc, k) => {
  const c = components[k]
  if (c.doc) {
    acc[k] = c
  } else {
    acc[k] = documentComponent({
      name: c.name,
      description: 'This component has not been documented yet.',
    })(c)
  }
  return acc
}, {})
